<template>
  <div class="row">
    <div class="col-12">
      <custom-modal
        cancel-text="Cancelar"
        icon="fas fa-exclamation-circle"
        is-centered
        save-text="Aceptar"
        show-cancel
        show-save
        title="Someter Factura"
        :value="showModal"
        width="850px"
        @cancel="onCancelAcceptTermHandler"
        @save="handleAcceptSubmitBillTerm"
      >
        <custom-checkbox-single-option
          id="custom-checkbox-submit-bill"
          v-model="acceptedTerms"
          class="font-16"
          option-text="Acepto los términos y responsabilidades"
          :title="modalTitle"
        />
      </custom-modal>
      <custom-modal
        cancel-text="Cancelar"
        icon="fas fa-exclamation-circle"
        is-centered
        save-text="Aceptar"
        show-cancel
        show-save
        title="Certificación de Aprobación"
        :value="showModalPendingApproval"
        width="550px"
        @cancel="onCancelAcceptTermHandler"
        @save="onSubmitChangeBillingStatus"
      >
        <custom-checkbox-single-option
          id="custom-checkbox-submit-bill"
          v-model="acceptedTerms"
          class="font-16"
          option-text="Acepto los términos y responsabilidades"
          :title="modalTitlePendingApproval"
        />
      </custom-modal>
      <custom-modal
        cancel-text="Cancelar"
        icon="fas fa-exclamation-circle"
        is-centered
        save-text="Aceptar"
        show-cancel
        show-save
        title="Certificación de Aprobación"
        :value="showModalApproval"
        width="550px"
        @cancel="onCancelAcceptTermHandler"
        @save="onSubmitChangeBillingStatus"
      >
        <custom-checkbox-single-option
          id="custom-checkbox-submit-bill"
          v-model="acceptedTerms"
          class="font-16"
          option-text="Acepto los términos y responsabilidades"
          title="Certifico que la factura fue preintervenida de acuerdo con los clausulas del contrato."
        />
      </custom-modal>
      <page-header :page="headerConfig">
        <template #customActions>
          <div v-if="!showChangeBillingStatus">
            <action-button
              v-if="!showChangeBillingStatus"
              id="billing-history-management-button-back"
              class="mr-2"
              i="fas fa-arrow-circle-left fa-fw"
              text="Regresar"
              variant="outline-success"
              @click="back"
            />
          </div>

          <drop-down
            v-if="canReportDownload && !showChangeBillingStatus"
            class="mr-2"
            icon="fa fa-folders"
            :items="reportItems"
            title="Informes"
          />
          <action-button
            v-if="showBilledServicesCertification && !showChangeBillingStatus"
            id="billed-certificates-certification-button"
            class="mr-2"
            i="fa fa-file-alt"
            text="Certificación de Servicios Facturados"
            variant="success"
            @click="getBillingServicesCertification"
          />
          <action-button
            v-if="canUpdateBill"
            id="billing-history-management-button-update-bill"
            class="mr-2"
            i="fas fa-redo-alt pr-2"
            text="Actualizar factura"
            variant="outline-success"
            @click="onUpdateBill"
          />
          <action-button
            v-if="
              ((canChangeBillingStatus || canRevertSentToFinanceToApproved) &&
                !showChangeBillingStatus) ||
                canAlwaysShowChangeBillingStatus
            "
            id="billing-history-management-button-change-status"
            class="mr-2"
            i="fas fa-exchange-alt"
            text="Cambiar Estatus"
            variant="success"
            @click="onChangeBillingStatusHandler"
          />
          <action-button
            v-if="canSubmitBill"
            id="billing-history-management-button-submit"
            class="mr-2"
            :disabled="isDisabledSubmitBill"
            i="fas fa-flag pr-2"
            text="Someter"
            variant="success"
            @click="onSubmitBillClick"
          />
          <action-button
            v-if="
              billingInfoTabIndex === billingInfoTabs.ADJUSTMENT &&
                !showAdjustment &&
                showAdjustmentBtn
            "
            class="mr-2"
            i="fas fa-money-check-alt pr-2"
            text="Ajustar Factura"
            variant="success"
            @click="adjustBill()"
          />
        </template>
      </page-header>
    </div>
    <div class="col-12">
      <bill-change-status
        v-if="showChangeBillingStatus"
        :billing-status-list-available="billingChangeStatusListAvailable"
        @on-cancel-change-billing-status="showChangeBillingStatus = false"
        @on-submit-change-billing-status="onSubmitChangeBillingStatusHandler"
      />
    </div>
    <div class="col-12">
      <adjustment-bill
        v-if="
          billingInfoTabIndex === billingInfoTabs.ADJUSTMENT && showAdjustment
        "
        :bill-id="this.billId"
        :show-evidence-attachment="canShowEvidence"
        @on-cancel="showAdjustment = false"
        @reload-results="onUpdateBill('e')"
      />
    </div>
    <div class="col-12">
      <board :details="billBoardDetails" />
    </div>
    <div class="col-12 mt-3">
      <custom-tab
        key="f"
        class="custom-nav-container custom-nav-colors font-18"
        content-class="mt-3 pb-5 font-18"
        :nav-class="'font-18'"
        :no-nav-style="true"
      >
        <custom-tab-item
          :active="billingInfoTabIndex === billingInfoTabs.SUMMARY"
          class="mt-3"
          lazy
          title="Resumen"
          @click="onChangeInfoTab(billingInfoTabs.SUMMARY)"
        >
          <div class="row mt-4 mb-5 ml-2">
            <div class="col-md-4 col col-sm-6">
              <total-amount-view
                :key="keyquantity"
                :amount="summaryTotals.subTotal | price"
                icon="fa fa-usd-circle"
                icon-color="color-yellow-star"
                title="Sub-Total de la Factura"
              />
            </div>
            <template v-if="canShowTotalAdjustment">
              <div class="col-md-4 col col-sm-6 mt-3 mt-md-0 mt-sm-3">
                <total-amount-view
                  :key="keyquantity"
                  :amount="summaryTotals.adjustment | price"
                  icon="fa fa-usd-circle"
                  :icon-color="adjustmentColor(summaryTotals.adjustment)"
                  title="Total de Ajustes"
                />
              </div>
              <div
                class="col-md-4 col col-sm-6 mt-md-0 mt-sm-3 mt-3 mt-md-0 mt-sm-3"
              >
                <total-amount-view
                  :key="keyquantity"
                  :amount="summaryTotals.total | price"
                  icon="fa fa-usd-circle"
                  icon-color="color-green"
                  title="Total de la Factura"
                />
              </div>
            </template>
            <template v-else>
              <div class="col-md-8 col col-sm-6 mt-3 mt-md-0 mt-sm-3">
                <div class="row">
                  <div class="col-md-6 col col-sm-6 mt-3 mt-md-0 mt-sm-3">
                    <total-amount-view
                      icon="fa fa-usd-circle"
                      icon-color="color-primary-8"
                      title="Total de Ajustes"
                      title-class="mt-2"
                    />
                  </div>
                  <div class="col-md-6 col col-sm-6 mt-3 mt-md-0 mt-sm-3">
                    <total-amount-view
                      icon="fa fa-usd-circle"
                      icon-color="color-green"
                      title="Total de la Factura"
                      title-class="mt-2"
                    />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col">
                    <div class="d-flex flex-column">
                      <div class="color-black font-weight-bold font-16">
                        No se presenta el total de la factura ya que se
                        encuentra en {{ getBillStatusDescription }}.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div>
            <section-title :has-line="true" title="Resumen General" />
            <div class="container-fluid row mt-4 mb-4 mx-auto">
              <service-type-view
                v-if="showServiceTypeInterventionSummary"
                :amount-total="serviceTotals.interventionsServiceAmount | price"
                class="col-md-4 col-sm-12 mt-md-0 mt-sm-3 mb-4 pr-5"
                main-icon="fa fa-clipboard-list-check"
                main-title="Resumen de Intervenciones Registradas"
                :service-total="
                  serviceTotals.interventionsServiceCount
                    ? serviceTotals.interventionsServiceCount.toString()
                    : '0'
                "
              />
              <service-type-view
                v-if="showServiceTypeEvaluationSummary"
                :amount-total="serviceTotals.evaluationServiceAmount | price"
                class="col-md-4 col-sm-12 mt-5 mt-md-0 mt-sm-5 pr-5"
                :class="{ 'corner-line': showServiceTypeInterventionSummary }"
                main-icon="fa fa-clipboard-list-check"
                main-title="Resumen de Evaluaciones Registradas"
                :service-total="
                  serviceTotals.evaluationServiceCount
                    ? serviceTotals.evaluationServiceCount.toString()
                    : '0'
                "
              />
              <service-type-view
                v-if="showServiceTypeAssitanceSummary"
                :amount-total="serviceTotals.assistenceServiceAmount | price"
                class="col-md-4 col-sm-12 pr-5 mt-5 mt-md-0 mt-sm-5"
                :class="{ 'corner-line': showServiceTypeEvaluationSummary }"
                main-icon="fa fa-clipboard-list-check"
                main-title="Resumen de Registro de Asistente de Servicios"
                :service-total="
                  serviceTotals.assistenceServiceCount
                    ? serviceTotals.assistenceServiceCount.toString()
                    : '0'
                "
              />
            </div>
            <section-title
              :has-line="true"
              title="Resumen de Alerta de Servicios"
            />
            <div class="container-fluid row mt-4 mb-5">
              <div class="col-md-4">
                <service-alert-view
                  :count="alerts.visitsError"
                  description="Servicios en la factura que tienen error en las visitas registradas."
                  main-title="Errores de Visita:"
                  @print="getVisitsErrorAlert"
                />
              </div>
              <div class="col-md-4">
                <service-alert-view
                  :count="alerts.withoutMassCertification"
                  description="Servicios en la factura que no tienen anejado la certificación de servicio mensual."
                  main-title="Carga de Certificaciones de Servicios Mensuales:"
                  @print="getWithoutVisitCertificationAlert"
                />
              </div>
              <div class="col-md-4">
                <service-alert-view
                  :count="alerts.noEnded"
                  description="Servicios en la factura que no han sido finalizados."
                  main-title="No Finalizados:"
                  @print="getNotFinishedAlert"
                />
              </div>
            </div>
          </div>
        </custom-tab-item>
        <custom-tab-item
          class="mt-3"
          lazy
          title="Detalle"
          @click="onChangeInfoTab(billingInfoTabs.DETAIL)"
        >
          <contract-search
            :bill="billModel"
            :is-read-only="isReadOnly"
            :status-id="billingStatusId"
          />
        </custom-tab-item>
        <custom-tab-item
          v-if="showDocumentTab"
          class="mt-3"
          lazy
          title="Documentos"
          @click="onChangeInfoTab(billingInfoTabs.DOCUMENTS)"
        >
          <bill-documents :data="billModel" :info="infoFilter" />
        </custom-tab-item>
        <custom-tab-item
          class="mt-3"
          lazy
          title="Historial"
          @click="onChangeInfoTab(billingInfoTabs.HISTORY)"
        >
          <billing-history-detail :bill-id="this.billId" />
        </custom-tab-item>
        <custom-tab-item
          v-if="showAdjustmentTab"
          :active="billingInfoTabIndex === billingInfoTabs.ADJUSTMENT"
          class="mt-3"
          lazy
          title="Ajustes"
          @click="onChangeInfoTab(billingInfoTabs.ADJUSTMENT)"
        >
          <billing-adjustment-detail
            :key="keyReload"
            :bill-id="this.billId"
            :bill-status="billingStatusId"
            class="mt-5"
            lazy
            @reload-quantity="onUpdateBill('quantity')"
          />
        </custom-tab-item>
        <custom-tab-item
          v-if="showPaymentTab"
          :active="billingInfoTabIndex === billingInfoTabs.PAYMENT"
          class="mt-3"
          lazy
          title="Pagos"
          @click="onChangeInfoTab(billingInfoTabs.PAYMENT)"
        >
          <billing-payment-detail :bill-id="this.billId" class="mt-5" lazy />
        </custom-tab-item>
        <custom-tab-item
          v-if="showExecutionSummaryTab"
          class="mt-3"
          lazy
          title="Resumen de Ejecución"
          @click="onChangeInfoTab(billingInfoTabs.EXECUTION_SUMMARY)"
        >
          <billing-execution-summary :bill-id="this.billId" class="mt-5" lazy />
        </custom-tab-item>
      </custom-tab>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import SectionTitle from 'SectionTitle';
import ContractSearch from './components/billDetail/ContractSearch.vue';
import BillingHistoryDetail from './components/billHistory/BillingHistoryDetail.vue';
import Board from 'Board';
import DropDown from 'dropdown';
import ActionButton from 'ActionButton';
import TotalAmountView from './components/billResume/TotalAmountView.vue';
import ServiceTypeView from './components/billResume/ServiceTypeView.vue';
import ServiceAlertView from './components/billResume/ServiceAlertView.vue';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import CustomModal from 'CustomModal';
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';
import storeMixin from '@quisit/mipe-utils/mixins/storeGenerator';
import BillingExecutionSummary from './components/billExecutionSummary/BillingExecutionSummary.vue';
import {
  getBillingDetails,
  getBillingStatusTransition,
  updateBillingStatus,
  submitBillValidation,
  updateBillingAmounts,
  validateBill,
  hasDocumentExpired,
} from '@/services/provider/billing-history.api';

import ReportServices from '@/services/common/report.api';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import utils from '@/utils/utilities';
import billingStatus from '@/utils/constants/billingStatus';
import BillChangeStatus from './components/BillChangeStatus.vue';
import BillDocuments from './components/billDocument/BillDocuments.vue';
import BillingAdjustmentDetail from './components/billAdjustment/BillingAdjustmentDetail.vue';
import AdjustmentBill from './components/billAdjustment/components/Adjustment.vue';
import BillingPaymentDetail from './components/billPayment/BillingPaymentDetail.vue';
import { getAdjustmentsummary as _getAdjustmentsummary } from '@/services/provider/billing-history.api';
import roles from '@/utils/constants/roles.js';

const BILLING_INFO_TABS = {
  SUMMARY: 0,
  DETAIL: 1,
  DOCUMENTS: 2,
  HISTORY: 3,
  ADJUSTMENT: 4,
  PAYMENT: 5,
  EXECUTION_SUMMARY: 6,
};

export default {
  name: 'BillingHistoryManagement',
  mixins: [alertMixin, storeMixin],
  components: {
    PageHeader,
    Board,
    ContractSearch,
    SectionTitle,
    CustomTab,
    CustomTabItem,
    TotalAmountView,
    ServiceTypeView,
    ServiceAlertView,
    DropDown,
    ActionButton,
    BillingHistoryDetail,
    BillChangeStatus,
    BillDocuments,
    CustomModal,
    CustomCheckboxSingleOption,
    BillingAdjustmentDetail,
    AdjustmentBill,
    BillingPaymentDetail,
    BillingExecutionSummary,
  },
  data() {
    return {
      keyReload: 1,
      billId: null,
      billModel: null,
      keyResults: 1,
      billingInfoTabIndex: 0,
      showModal: false,
      showModalPendingApproval: false,
      showModalApproval: false,
      infoFilter: null,
      acceptedTerms: false,
      showChangeBillingStatus: false,
      billingChangeStatusListAvailable: [],
      showAdjustment: false,
      keyquantity: 1,
      summaryTotals: {
        subTotal: 0,
        adjustment: 0,
        total: 0,
      },
      serviceTotals: {
        interventionsServiceCount: 0,
        evaluationServiceCount: 0,
        assistenceServiceCount: 0,
        interventionsServiceAmount: 0,
        evaluationServiceAmount: 0,
        assistenceServiceAmount: 0,
      },
      alerts: {
        visitsError: 0,
        withoutMassCertification: 0,
        noEnded: 0,
      },
      adjustmentSummary: {
        automaticAdjustmentAmount: 0,
        automaticAdjustmentCount: 0,
        manualAdjustmentAmount: 0,
        manualAdjustmentCount: 0,
        totalAdjustmentAmount: 0,
        totalAdjustmentCount: 0,
        totalObjectionCount: 0,
      },
      canShowExecutionSummary: false,
      validStatuses: [
        billingStatus.EnProcesoIntervencion,
        billingStatus.PendienteRevision,
        billingStatus.PendienteIntervencionObjetada,
        billingStatus.EnProcesoIntervencionObjetada,
        billingStatus.PendienteAprobacion,
        billingStatus.Aprobado,
        billingStatus.EnviadoFinanzas,
        billingStatus.EnviadoFinanzasParcial,
        billingStatus.DevueltoTPFA,
        billingStatus.EnProcesoPago,
        billingStatus.Pagado,
      ],
    };
  },
  computed: {
    isReadOnly() {
      return this.billModel?.statusId == billingStatus.PendienteInformacion;
    },
    headerConfig() {
      return {
        title: 'Detalle de Factura',
        icon: 'fas fa-user-tie',
        routes: ['Inicio', 'Proveedor', 'Historial de Facturas', 'Ver'],
      };
    },
    canReportDownload() {
      return this.userHasPermissions(
        'rempro.providers.billinghistory.reportdownload'
      );
    },
    canShowEvidence() {
      return this.userHasPermissions(
        'rempro.providers.billinghistory.positiveadjustmentbill'
      );
    },
    canUpdateBill() {
      return (
        this.billModel?.statusId == billingStatus.Preliminar &&
        this.userHasPermissions('rempro.providers.billinghistory.updatebill') &&
        this.billingInfoTabIndex == this.billingInfoTabs.SUMMARY
      );
    },
    getBillStatusDescription() {
      if (this.billModel?.statusId == billingStatus.EnProcesoIntervencion) {
        return 'Proceso de Intervención';
      }
      if (
        this.billModel?.statusId == billingStatus.EnProcesoIntervencionObjetada
      ) {
        return 'Proceso de Intervención Objetada';
      }
      return '';
    },
    isDisabledSubmitBill() {
      var isDisabled = this.billModel.monthNumber != new Date().getMonth() + 1;
      return !isDisabled;
    },
    canSubmitBill() {
      return (
        (this.billModel?.statusId == billingStatus.Preliminar &&
          this.userHasPermissions(
            'rempro.providers.billinghistory.submitbill'
          )) ||
        (this.billModel?.statusId == billingStatus.PendienteInformacion &&
          this.userHasPermissions(
            'rempro.providers.billinghistory.submit.pendinginformation'
          )) ||
        (this.billModel?.statusId == billingStatus.PendienteRevision &&
          this.userHasPermissions('rempro.billinghistory.submitpendingreview'))
      );
    },
    canAlwaysShowChangeBillingStatus() {
      return this.userHasPermissions(
        'rempro.providers.billinghistory.alwaysChange'
      );
    },
    canChangeBillingStatus() {
      return (
        [
          billingStatus.PendienteIntervencion,
          billingStatus.EnProcesoIntervencion,
          billingStatus.PendienteIntervencionObjetada,
          billingStatus.EnProcesoIntervencionObjetada,
          billingStatus.PendienteAprobacion,
        ].includes(this.billModel?.statusId) &&
        this.isAvailableBillingStatusList &&
        !this.userHasPermissions('rempro.providers.billinghistory.submitbill') //Avoid Providers or users has can submit
      );
    },
    canviewAdjustmentsReports() {
      return (
        this.hasAdjustments &&
        [
          billingStatus.PendienteRevision,
          billingStatus.PendienteAprobacion,
          billingStatus.EnProcesoPago,
          billingStatus.Pagado,
        ].includes(this.billModel?.statusId)
      );
    },
    canShowTotalAdjustment() {
      if (this.billModel?.statusId == billingStatus.EnProcesoIntervencion) {
        return this.userHasPermissions(
          'rempro.providers.billinghistory.showadjustmentandtotaloninterventionprocess'
        );
      }
      if (
        this.billModel?.statusId == billingStatus.EnProcesoIntervencionObjetada
      ) {
        return this.userHasPermissions(
          'rempro.providers.billinghistory.showadjustmentandtotalonobjectedinterventionprocess'
        );
      }
      return true;
    },
    isAvailableBillingStatusList() {
      return !!this.billingChangeStatusListAvailable?.length;
    },
    showAdjustmentTab() {
      return this.billModel?.statusId != billingStatus.Preliminar;
    },
    showAdjustmentBtn() {
      return (
        this.billModel?.statusId == billingStatus.PendienteAprobacion &&
        this.userHasPermissions('rempro.providers.billinghistory.adjustbill')
      );
    },
    showExecutionSummaryTab() {
      return (
        this.validStatuses.includes(this.billModel?.statusId) &&
        this.canShowExecutionSummary &&
        (this.userRoleId === roles.Director_URP ||
          this.userRoleId === roles.Admin_RP)
      );
    },
    showPaymentTab() {
      return [
        billingStatus.EnviadoFinanzasParcial,
        billingStatus.EnviadoFinanzas,
        billingStatus.DevueltoTPFA,
        billingStatus.PagadoParcial,
        billingStatus.Pagado,
      ].includes(this.billModel?.statusId);
    },
    showDocumentTab() {
      return this.userHasPermissions(
        'rempro.providers.billinghistory.showdocumenttab'
      );
    },
    showBillingCertificationService() {
      return (
        this.userHasPermissions(
          'rempro.providers.billinghistory.downloadcertificationbilledservices'
        ) &&
        [
          billingStatus.PendienteAprobacion,
          billingStatus.Aprobado,
          billingStatus.EnProcesoPago,
          billingStatus.Pagado,
        ].includes(this.billModel?.statusId)
      );
    },
    showBilledServicesCertification() {
      return (
        ([roles.AdminIL, roles.Admin_RP].includes(this.userRoleId) ||
          this.userHasPermissions(
            'rempro.providers.billinghistory.billedservicescertification'
          )) &&
        [
          billingStatus.PendienteAprobacion,
          billingStatus.Aprobado,
          billingStatus.EnProcesoEnvioFinanzas,
          billingStatus.EnProcesoPago,
          billingStatus.PendienteLiberacion,
          billingStatus.EnviadoFinanzas,
          billingStatus.EnviadoFinanzasParcial,
          billingStatus.PendienteAprobacionTPFA,
          billingStatus.DevueltoTPFA,
          billingStatus.PagadoParcial,
          billingStatus.Pagado,
        ].includes(this.billModel?.statusId)
      );
    },
    showServiceTypeAssitanceSummary() {
      return this.serviceTotals.assistenceServiceCount > 0;
    },
    showServiceTypeEvaluationSummary() {
      return this.serviceTotals.evaluationServiceCount > 0;
    },
    showServiceTypeInterventionSummary() {
      return this.serviceTotals.interventionsServiceCount > 0;
    },
    reportItems() {
      const items = [];

      items.push({
        label: 'Excel Master de Servicios',
        icon: 'fa fa-file-alt color-green',
        click: () => this.getExcelMaster(),
        border: 'top',
      });

      if (this.showBillingCertificationService && this.canChangeBillingStatus) {
        items.push({
          label: 'Certificación de Servicios Facturados',
          icon: 'fa fa-file-alt color-green',
          click: () => this.getBillingCertificationService(),
        });
      }

      if (this.canviewAdjustmentsReports) {
        items.push(
          {
            label: 'Informe de Ajustes',
            icon: 'fa fa-file-alt color-green',
            click: () => this.getBillingAdjustmentReport(),
            border: 'top',
          },
          {
            label: 'Detalle de Ajustes',
            icon: 'fa fa-file-alt color-green',
            click: () => this.getPreliminaryBillingReport(),
            border: 'top',
          }
        );
      }
      return items;
    },
    billBoardDetails() {
      return [
        [
          {
            label: 'Año Fiscal:',
            icon: 'fas fa-calendar-edit',
            cols: 'col-md-4 pt-2',
            data: this.billModel?.academicYearDescription,
          },
          {
            label: 'Número Factura:',
            icon: 'fas fa-file-invoice',
            cols: 'col-md-4 pt-2',
            data: this.billModel?.billNumber,
          },
          {
            label: 'Mes:',
            icon: 'fas fa-calendar-edit',
            cols: 'col-md-4 pt-2',
            data: this.billModel?.period,
          },
          {
            label: 'Estatus:',
            icon: 'fas fa-ballot-check',
            cols: 'col-md-4 pt-2',
            data: this.billModel?.statusName,
          },
          {
            label: 'Proveedor:',
            icon: 'fas fa-address-book',
            cols: 'col-md-4 pt-2',
            data: this.billModel?.provider,
          },
        ],
      ];
    },
    billingInfoTabs() {
      return BILLING_INFO_TABS;
    },
    defaultBillingTabIndex() {
      return this.billingInfoTabs.SUMMARY;
    },
    isPreliminar() {
      return this.billModel?.statusId === billingStatus.Preliminar;
    },
    isPendingInformation() {
      return this.billModel?.statusId === billingStatus.PendienteInformacion;
    },
    isPendingReview() {
      return (
        this.adjustmentSummary.totalAdjustmentCount !=
          this.adjustmentSummary.totalObjectionCount &&
        this.billModel?.statusId === billingStatus.PendienteRevision
      );
    },
    modalTitle() {
      return 'Bajo pena de nulidad certifico que ningún servidor público de la entidad gubernamental es parte o tiene algún interés en las ganancias o beneficios productos del contrato ha mediado una dispensa previa. La única consideración para suministrar los bienes o servicios objeto del contrato ha sido el pago acordado con el representante autorizado de la entidad gubernamental. El importe de esta factura es justo y correcto. Los trabajos han sido realizados, los productos han sido entregados y los servicios han sido prestados, y no se ha recibido pago por ellos. Declaro haber completado toda la factura mensual y haber certificado correctamente conforme a los servicios brindados y por ende no responsabilizaré al Departamento de Educación por la información incorrecta sometida, tampoco exigiré pago alguno por dichos servicios no facturados. Acepto ser responsable de la veracidad y corrección de la información provista en la factura en línea.';
    },
    modalTitlePendingApproval() {
      return 'Certifico que la factura fue preintervenida de acuerdo con las clausulas del contrato.';
    },
    billingStatusId() {
      return this.billModel?.statusId;
    },
    hasPersistedCurrentBilling() {
      return (
        parseInt(this.$route.params.billId) ===
        parseInt(this.moduleData?.ContractSearch?.billId)
      );
    },
    hasAdjustments() {
      return this.billModel?.totalAdjustmentCount > 0;
    },
    adjustmentColor() {
      return (amount) => {
        return amount >= 0 ? 'color-primary-8' : 'color-red';
      };
    },
    hasSifdeRevertPermission() {
      return this.userHasPermissions(
        'rempro.provider.billing.sifde.revertinpaymentprocesstoapproved'
      );
    },
    isDirectorUrp() {
      return this.userRoleId === roles.Director_URP;
    },
    // User Story ID: 158636
    hasRevertSentToFinancePermission() {
      return this.userHasPermissions(
        'rempro.providers.billinghistory.revertsenttofinancetoapproved'
      );
    },
    canRevertSentToFinanceToApproved() {
      return (
        this.billModel?.statusId === billingStatus.EnviadoFinanzas &&
        (this.isDirectorUrp || this.hasRevertSentToFinancePermission) &&
        this.isAvailableBillingStatusList
      );
    },
  },
  methods: {
    adjustBill() {
      this.showAdjustment = true;
    },
    back() {
      this.$router.go(-1);
    },
    async onChangeInfoTab(tabIndex) {
      this.billingInfoTabIndex = tabIndex;
      if (this.billingInfoTabIndex == this.billingInfoTabs.SUMMARY) {
        await this.getDetailsInfo();
      }
    },
    async getDetailsInfo() {
      let { data } = await getBillingDetails(this.billId);

      if (!data) return;

      this.billModel = data;

      //Resumen totales
      this.summaryTotals.subTotal = data.totalServiceCostAmount;
      this.summaryTotals.adjustment = data.totalAdjustmentAmount;
      this.summaryTotals.total = data.totalBillAmount;

      //Totales de Servicios
      if (data.serviceTotalSummary)
        this.serviceTotals = data.serviceTotalSummary;

      //Alertas
      this.alerts.visitsError = data.visitsErrorAlerts;
      this.alerts.noEnded = data.notEndedAlerts;
      this.alerts.withoutMassCertification = data.withoutCertificationAlerts;
      this.canShowExecutionSummary = data.canShowExecutionSummary;

      await this.getTotalInfo();
    },
    async getTotalInfo() {
      const { data } = await _getAdjustmentsummary(this.billId);
      if (data) this.adjustmentSummary = data;
    },
    async onUpdateBill(e) {
      if (e == 'quantity') {
        this.keyquantity = this.keyquantity * -1;
        await this.refreshBillingAmounts();
      } else {
        this.keyReload = this.keyReload * -1;
        await this.refreshBillingAmounts();
      }
    },
    async refreshBillingAmounts() {
      await updateBillingAmounts(this.billId).then(async () => {
        await this.getDetailsInfo();
        await this.loadBillingStatusesAvailable();
      });
    },
    async getVisitsErrorAlert() {
      try {
        const payload = {
          billId: this.billId,
        };
        const response = await ReportServices.getReport('visitErrors', payload);
        utils.convertToBlob(response.data);
      } catch (err) {
        this.ShowToast('', err.response?.data?.message, 'error');
      }
    },
    async getNotFinishedAlert() {
      await ReportServices.getBillingReport('serviceNotFinalized', this.billId)
        .then((res) => utils.convertToBlob(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    async getWithoutVisitCertificationAlert() {
      await ReportServices.getBillingReport(
        'serviceWithoutCertification',
        this.billId
      )
        .then((res) => utils.convertToBlob(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    async getBillingCertificationService() {
      await ReportServices.getBillingReport('billingcertification', this.billId)
        .then((res) => utils.convertToBlob(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    async getExcelMaster() {
      await ReportServices.getBillingReport('excelmasterservices', this.billId)
        .then((res) => utils.convertToBlob(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    async getBillingServicesCertification() {
      await ReportServices.getBillingReport(
        'billingservicescertification',
        this.billId
      )
        .then((res) => utils.convertToBlob(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    async loadBillingStatusesAvailable() {
      const { data } = await getBillingStatusTransition(this.billId);
      this.billingChangeStatusListAvailable = data;
    },
    async onChangeBillingStatusHandler() {
      this.showChangeBillingStatus = !this.showChangeBillingStatus;
    },
    async onSubmitChangeBillingStatusHandler(model) {
      this.billModel.comment = model.comment;
      this.billModel.billStatus = model.billStatus;
      if (model.billStatus.id == billingStatus.PendienteAprobacion) {
        this.showModalPendingApproval = true;
        return;
      }
      if (model.billStatus.id == billingStatus.Aprobado) {
        this.showModalApproval = true;
        return;
      }

      await this.onSubmitChangeBillingStatus();
    },
    async onSubmitChangeBillingStatus() {
      const termsApprovalRequiredStatuses = [
        billingStatus.PendienteAprobacion,
        billingStatus.Aprobado,
      ];

      if (
        termsApprovalRequiredStatuses.includes(this.billModel.billStatus.id)
      ) {
        if (!this.acceptedTerms) {
          this.ShowToast(
            'Alerta',
            'Favor aceptar los términos y responsabilidades.',
            'error'
          );

          return;
        }
      }

      this.showModalPendingApproval = false;
      this.acceptedTerms = false;
      this.showModalApproval = false;
      const { data: result } = await updateBillingStatus({
        billId: this.billId,
        newBillingStatus: this.billModel.billStatus.id,
        comment: this.billModel.comment,
        // User Story ID: 158636 - the source status guard mirrors the backend check so the
        // 'Enviado a Finanzas' revert never triggers the SIFDE voucher reset.
        changedToApprovedForSifdeReset:
          this.hasSifdeRevertPermission &&
          this.billModel.billStatus.selected &&
          this.billModel.statusId === billingStatus.EnProcesoPago,
      });

      if (!result.isValid) {
        this.ShowToast('', result.message, 'error');
        return;
      }

      this.ShowToast(
        'Proceso Exitoso.',
        'El estatus ha sido cambiado exitosamente.',
        'success'
      );
      this.showChangeBillingStatus = false;
      await this.getDetailsInfo();
      await this.loadBillingStatusesAvailable();
    },
    onCancelAcceptTermHandler() {
      this.showModal = false;
      this.showModalPendingApproval = false;
      this.showModalApproval = false;
      this.acceptedTerms = false;
    },
    async onSubmitBillClick() {
      const { data } = await hasDocumentExpired(this.billId);
      var answer = true;
      if (data) {
        this.ShowToast(
          'Alerta',
          'No es posible someter la factura ya que cuenta con un documento de su solicitud de proveedor con fecha de documentos vencida. Favor acceda a su perfil de proveedor para ver más detalles.',
          'error'
        );
        return;
      }
      if (this.isPreliminar) {
        const { billId } = this.billModel;

        const payload = {
          billId,
          academicYearId: this.billModel.academicYearId,
          companyId: this.billModel.companyId,
          monthNumber: this.billModel.monthNumber,
        };

        try {
          let isSuccess = true;
          const { data: validations } = await validateBill(payload);

          if (validations?.length > 0) {
            validations.forEach((item) => {
              if (!item.isValid) {
                this.Toast('Alerta', item.message, 'error', 10000);
                isSuccess = false;
              }
            });
          }
          if (isSuccess) {
            this.showModal = true;
            return;
          }
          if (!isSuccess) return;
        } catch (err) {
          this.ShowToast(
            'Alerta',
            err?.response?.data?.message || 'error',
            'error'
          );
        }
      } else if (this.isPendingInformation) {
        answer = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro(a) que desea someter la factura?`,
          'Sí',
          'No'
        );
      } else if (this.isPendingReview) {
        answer = await this.ShowCancelModal(
          'Confirmación',
          `Usted cuenta con ajuste(s) pendiente(s) de objetar, ¿Está seguro(a) que desea someter la factura?`,
          'Sí',
          'No'
        );
      }
      if (!answer) return;

      this.acceptedTerms = true;
      this.onSumbitBill();
    },
    async handleAcceptSubmitBillTerm() {
      this.acceptedTerms = true;
      this.showModal = false;
      this.onSumbitBill();
    },
    async onSumbitBill() {
      const { billId } = this.billModel;
      let billModelChanged = false;

      if (this.isPreliminar) {
        const oldBillModel = {
          totalBillAmount: this.billModel.totalBillAmount,
          updatedDate: this.billModel.updatedDate,
        };

        await this.refreshBillingAmounts();

        const { billId } = this.billModel;
        const payload = {
          billId,
          academicYearId: this.billModel.academicYearId,
          companyId: this.billModel.companyId,
          monthNumber: this.billModel.monthNumber,
        };
        const { data: validations } = await validateBill(payload);

        if (validations?.length > 0) {
          var validationResult = true;
          validations.forEach((item) => {
            if (!item.isValid) {
              this.Toast('Alerta', item.message, 'error', 10000);
              validationResult = false;
            }
          });

          if (!validationResult) {
            return false;
          }
        }
        billModelChanged =
          oldBillModel.totalBillAmount != this.billModel.totalBillAmount &&
          oldBillModel.updatedDate != this.billModel.updatedDate;
      }

      if (billModelChanged) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          `Hubo un cambio en el monto de la factura, ¿está seguro(a) que desea Someter la factura <b>${this.billModel.billNumber}</b>?`,
          'Sí',
          'No'
        );

        if (!answer) return;
      }

      if (this.isPreliminar) {
        if (!this.acceptedTerms) {
          this.ShowToast(
            'Alerta',
            'Favor aceptar los términos y responsabilidades.',
            'error'
          );
          return;
        }
      }

      const payload = {
        billId,
        academicYearId: this.billModel.academicYearId,
        companyId: this.billModel.companyId,
        monthNumber: this.billModel.monthNumber,
      };

      try {
        let isSuccess = true;
        const { data: validations } = await submitBillValidation(payload);

        if (validations?.length > 0) {
          validations.forEach((item) => {
            if (!item.isValid) {
              this.Toast('Alerta', item.message, 'error', 10000);
              isSuccess = false;
            }
          });
        }
        if (isSuccess) {
          this.ShowToast(
            'Proceso Exitoso.',
            'El estatus ha sido cambiado exitosamente.',
            'success'
          );
          await this.getDetailsInfo();
        }
      } catch (err) {
        this.ShowToast(
          'Alerta',
          err?.response?.data?.message || 'error',
          'error'
        );
      }
    },
    async getBillingAdjustmentReport() {
      await ReportServices.getBillingReport(
        'excelBillingAdjustment',
        this.billId
      )
        .then((res) => utils.convertToBlob(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    async getPreliminaryBillingReport() {
      await ReportServices.getBillingReport('preliminaryBilling', this.billId)
        .then((res) => utils.convertToBlob(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
  },
  async mounted() {
    this.billId = parseInt(this.$route.params.billId);
    this.infoFilter = this.$route.params.info;
    await this.getDetailsInfo();
    await this.loadBillingStatusesAvailable();
    if (this.hasPersistedCurrentBilling) {
      this.onChangeInfoTab(this.moduleData.ContractSearch.billingInfoTabIndex);
      return;
    }
    this.onChangeInfoTab(
      this.$route.params.tabIndex || this.defaultBillingTabIndex
    );
    this.$root.$on('reload-billing-statuses', () => {
      this.loadBillingStatusesAvailable();
    });
  },
  destroyed() {
    this.persistData();
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';
.custom-nav-colors {
  --tab-active-color: #ff7058 !important;
  --nav-link-color: #d0d0d0 !important;
  font-size: 18px !important;
  margin-bottom: 20px !important;
  --tab-font-size: 18px !important;
}
.corner-line {
  border-left: 3px solid map-get($colors, 'secondary-14');
}
</style>
